var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppointmentBookingHeader'),(_vm.showLogin)?_c('AppointmentLogin',{on:{"login":_vm.setUserData}}):(_vm.showCalendar)?_c('AppointmentBookingCalendar',{attrs:{"userData":_vm.user},on:{"booked":function($event){_vm.showCalendar = false}}}):_c('AppointmentBooked')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }